// extracted by mini-css-extract-plugin
export default {"page":"WhistleblowerSystem_page__+KFbt","email":"WhistleblowerSystem_email__f2WWN"};